<div [class]="selectClass" [style.--avatar-size.px]="avatarSize">
  @if (selectClass == 'main-class') {
    <button
      type="button"
      class="selectImageBox"
      [class.has-image]="croppedImage != undefined || imageSelected != null"
      (click)="openImageLoader()">
      <span class="slot-title">{{title}}</span>
      <span class="dashedFrame">
        @if (croppedImage != undefined) {
          <img class="croppedImage" [src]="croppedImage" [alt]="title">
          <span class="change-image">החלפת תמונה</span>
        } @else if (imageSelected != null) {
          <img class="croppedImage" [src]="imageSelected" [alt]="title">
          <span class="change-image">החלפת תמונה</span>
        } @else {
          <span class="upload-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 16V5M8 9l4-4 4 4"></path>
              <path d="M5 14v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4"></path>
            </svg>
          </span>
          <strong>לחצו להעלאת תמונה</strong>
          <small>JPG או PNG</small>
        }
      </span>
    </button>
  }

  @if (selectClass == 'personal-area') {
    <button type="button" class="selectImageBox" [class.is-readonly]="!editable" (click)="openImageLoader()" [attr.aria-label]="editable ? 'שינוי תמונת הפרופיל' : 'תמונת הפרופיל'">
      <span class="profileFrame">
        @if (croppedImage != undefined) {
          <img class="croppedImage" [src]="croppedImage" alt="תצוגה מקדימה של תמונת הפרופיל">
        } @else if (imageSelected) {
          <img class="croppedImage" [src]="imageSelected" alt="תמונת הפרופיל">
        } @else {
          <span class="profile-placeholder"><i class="mdi mdi-account-outline"></i></span>
        }
        <span *ngIf="editable" class="profile-edit" aria-hidden="true"><i class="mdi mdi-camera-outline"></i></span>
      </span>
      <span *ngIf="editable" class="profile-change-text">שינוי תמונה</span>
    </button>
  }
  <input #imageBoxInput class="inputFileInput" type="file" accept="image/*" (change)="fileChangeEvent($event)" />

  @if (cropperOpen) {
    <div class="FancyBoxImageCropper">
      <div class="cropper-dialog" role="dialog" aria-modal="true" aria-label="עריכת תמונה">
        <div class="cropper-header">
          <span>
            <strong>התאמת התמונה</strong>
            <small>מקמו את התמונה בתוך הריבוע — התוצאה תהיה 400×400</small>
          </span>
          <button type="button" class="cropper-close" [disabled]="isCompressing" (click)="closeWindow()" aria-label="סגירה">×</button>
        </div>
        <div class="cropper-stage">
          <div
            class="cropper-canvas cropper-canvas--{{ imageOrientation }}"
            [style.aspect-ratio]="imageAspectRatio">
            <image-cropper
              [class]="'image-cropper-box'"
              [maintainAspectRatio]="true"
              [aspectRatio]="1"
              [containWithinAspectRatio]="selectClass === 'personal-area'"
              [transform]="transform"
              [cropperMinWidth]="180"
              [cropperMinHeight]="180"
              [resizeToWidth]="outputImageSize"
              [resizeToHeight]="outputImageSize"
              [onlyScaleDown]="false"
              [format]="'jpeg'"
              [imageQuality]="85"
              [imageChangedEvent]="imageChangedEvent"
              (imageCropped)="imageCropped($event)"
              (imageLoaded)="imageLoaded($event)"
              (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()"
            ></image-cropper>
          </div>
          @if (selectClass === 'personal-area') {
            <div class="zoom-controls" aria-label="שליטה בגודל התמונה">
              <button type="button" (click)="zoomOut()" [disabled]="zoom <= 1" aria-label="הקטנת התמונה">−</button>
              <input type="range" min="1" max="3" step="0.1" [value]="zoom" (input)="onZoomChange($any($event.target).value)" aria-label="זום תמונה">
              <button type="button" (click)="zoomIn()" [disabled]="zoom >= 3" aria-label="הגדלת התמונה">+</button>
              <span>{{ (zoom * 100) | number:'1.0-0' }}%</span>
            </div>
          }
        </div>
        <div class="cropper-actions">
          <button type="button" class="cropper-secondary" [disabled]="isCompressing" (click)="closeWindow()">{{"sale4you.label.close" | translate}}</button>
          <button type="button" class="cropper-primary" [disabled]="isCompressing" (click)="cropImage()">
            @if (isCompressing) { מעבד תמונה... } @else { {{'sale4you.label.cropImage.cropBtn' | translate}} }
          </button>
        </div>
      </div>
    </div>
  }
</div>
